<template>
	<div v-if="availablePaymentMethods.length > 0" class="">
		<div class="form-group row">
			<div v-if="!hasValidInformation && showInvalid"
				class="col-12 pl-3">
				<div class="alert alert-warning">{{$t('please_select_payment_method')}}</div>
			</div>
			<div class="col-12">
				<div v-for="method in availablePaymentMethods" class="d-inline-flex mr-4 align-items-center" :key="method.id">
					<input class="checkbox" :id="'payment-method' + method.id" type="radio" name="payment_method" v-model="selectedPaymentMethodId" :value="method.id"/>
					<label class="d-inline-block ml-3 mb-0" :for="'payment-method' + method.id" v-if="method.method === 'manual'">{{ $t('manual_collect') }}</label>
					<label class="d-inline-block ml-3 mb-0" :for="'payment-method' + method.id" v-else-if="method.method === 'atm'">{{ $t('atm_transfer') }}</label>
					<label class="d-inline-block ml-3 mb-0" :for="'payment-method' + method.id" v-else-if="method.method === 'wait'">{{ $t('services.payment_wait') }}</label>
					<label class="d-inline-flex ml-3 mb-0" v-else :for="'payment-method' + method.id">
						<span>{{ $t('method.' + method.gateway.name) }}</span>
						<span v-if="method.gateway.name === 'tappay' && (provider.currency !== 'TWD' || currency !== 'TWD')"><small>&nbsp;{{ $t('settled_in_twd') }}</small></span>
					</label>
				</div>
				<p v-if="selectedPaymentMethod && selectedPaymentMethod.method === 'atm'" class="text-muted" style="white-space:pre-wrap;">{{provider.atm_bank_info}}</p>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="alert alert-danger">{{ $t('service_payment_methods_configuration_error') }}</div>
	</div>
</template>

<script>
import RootStore from '../stores/root';
import DingSelect from '../components/common/Select';
import { mapActions, mapGetters } from 'vuex';
import BookingPassBrowser from './booking/BookingPassBrowser';

export default {
	components: { DingSelect, BookingPassBrowser },
	store: RootStore,
	props: {
		provider: { required: true, type: Object },
		context: { required: true, type: Object },
		service: { required: true, type: Object },
	},
	computed: {
		...mapGetters({
			logistic: 'cart/logistic',
			currency: 'currencies/currency',
			paymentMethodId: 'cart/paymentMethodId',
		}),
		availablePaymentMethods() {
			const sorted = this.service.payment_methods.sort(function(a, b) {
				const scoreMap = {wait: -1, manual: 0, atm: 1};
				var aScore = 10;
				var bScore = 10;
				if(typeof scoreMap[a.method] !== 'undefined') {
					aScore = scoreMap[a.method];
				}
				if(typeof scoreMap[b.method] !== 'undefined') {
					bScore = scoreMap[b.method];
				}
				return aScore - bScore;
			});
			// 不是自取就不能用「到店付款」
			if (this.logistic && this.logistic.type !== 'FREE_OR_SELF_TAKEN') {
				return sorted.filter((m) => m.method !== 'manual');
			}
			return sorted;
		},
		hasValidInformation() {
			return this.selectedPaymentMethodId && this.availablePaymentMethods.some(payment => payment.id === this.selectedPaymentMethodId);
		},
		selectedPaymentMethod() {
			const matches = this.service.payment_methods.filter((m) => m.id === this.selectedPaymentMethodId);
			if (matches.length > 0) {
				return matches[0];
			}
			return null;
		}
	},
	methods: {
		...mapActions({
			setPaymentMethodId: 'cart/setPaymentMethodId'
		}),
		highlightInvalidState() {
			this.showInvalid = true;
		},
	},
	watch: {
		logistic() {
			if (this.selectedPaymentMethodId && (!this.logistic || this.logistic.type !== 'FREE_OR_SELF_TAKEN')) {
				const paymentMethod = this.service.payment_methods.find((m) => m.id === this.selectedPaymentMethodId)
				if (paymentMethod.method === 'manual') {
					this.selectedPaymentMethodId = null;
				}
			}
		},
		selectedPaymentMethodId(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.setPaymentMethodId(this.selectedPaymentMethodId);
			}
		},
		availablePaymentMethods() {
			if (this.availablePaymentMethods.length === 1) {
				this.selectedPaymentMethodId = this.availablePaymentMethods[0].id;
			}
		},
		service() {
			this.selectedPaymentMethodId = null;
		},
		paymentMethodId(newValue, oldValue) {
			if (newValue !== oldValue && newValue !== this.selectedPaymentMethodId) {
				this.selectedPaymentMethodId = this.paymentMethodId;
			}
		}
	},
	data() {
		return {
			selectedPaymentMethodId: null,
			showInvalid: false
		}
	},
	mounted() {
		if (!this.selectedPaymentMethodId && this.paymentMethodId) {
			this.selectedPaymentMethodId = this.paymentMethodId;
		}
	},
}
</script>

<style scoped>

.checkbox {
	width: 19px;
	height: 19px;
	position: relative;
	margin: 0;
}

</style>

<i18n>
{
	"zh": {
		"manual_collect": "到店付款",
		"service_payment_methods_configuration_error": "未設定可選的付款方式！請直接聯絡我們！",
		"method.linepay": "LINE Pay 線上付款",
		"method.tappay": "線上刷卡",
		"method.ecpay": "綠界 線上付款",
		"please_select_payment_method": "請選擇付款方式",
		"atm_transfer": "自行轉帳",
		"settled_in_twd": "(以新台幣結帳)"
	},
	"en": {
		"manual_collect": "Pay At Counter",
		"service_payment_methods_configuration_error": "No payment methods set up correctly, please contact us, thanks!",
		"method.tappay": "Credit Card via TapPay",
		"method.linepay": "Pay Online - LINE Pay",
		"method.ecpay": "Pay Online - ECPAY",
		"please_select_payment_method": "Please select payment method",
		"atm_transfer": "Bank Transfer",
		"self_transfer": "Bank Transfer",
		"settled_in_twd": "(Charged in TWD)"
	}
}
</i18n>